import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { forkJoin, Observable, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { ResourcesProvider } from 'core/models';
import { Router } from '@angular/router';

@Component({
  selector: 'lms-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit, OnDestroy {
  @Input() public resourcesProviders: ResourcesProvider[];
  public dropdownVisible = false;
  public searchTermStream = new Subject<string>();
  public searchResults = [];
  public term: string = '';

  constructor(public router: Router) {
    this.searchTermStream
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((term: string) => {
          this.term = term;
          this.dropdownVisible = false;
          return this.observableFromServices(encodeURIComponent(term));
        })
      )
      .subscribe((res) => {
        const searchResults = [];
        res.forEach((data, index) => {
          const provider = this.resourcesProviders[index];
          const { route, icon } = provider;
          searchResults.push(
            ...(data && data.docs
              ? data.docs.map((doc) => ({
                  id: doc.id,
                  label: this.getItemName(doc),
                  category: doc.clientName,
                  route,
                  icon
                }))
              : [])
          );
        });
        this.searchResults = searchResults;
        this.dropdownVisible = this.term && this.term.length > 2;
      });
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {
    this.searchTermStream.unsubscribe();
  }

  getItemName(item) {
    if (item) {
      const { name = '', surname = '', email = '' } = item;
      const fullName = `${name || ''} ${surname || ''}`.trim();
      return fullName || email;
    }
    return '';
  }

  onKeyup(term: any) {
    this.searchTermStream.next(term);
  }

  onSelected(item: any) {
    this.router.navigate([item.route, item.id], { replaceUrl: true });
  }

  observableFromServices(term: string): Observable<any> {
    const observableBatch = [];
    this.resourcesProviders.forEach((serviceObj) => {
      serviceObj.data = {};
      if (term !== '') {
        observableBatch.push(serviceObj.service.search(term, true, { limit: term && term.length > 5 ? 100 : 10 }));
      }
    });
    return forkJoin(observableBatch);
  }
}
